import React, { useEffect, useState } from 'react'
import {
  useSelector,
  // useDispatch
} from 'react-redux'
import { withRouter } from 'router'
import { Location as RouterLocation } from 'react-router'
import MenuLeft from './MenuLeft'
import MenuTop from './MenuTop'
// import styles from './style.module.scss'

let touchStartPrev = 0
let touchStartLocked = false

interface MenuProps {
  location: RouterLocation
}

const Menu: React.FC<MenuProps> = ({ location }) => {
  const menuLayoutType = useSelector((state: any) => state.appsettings.menuLayoutType)
  const isMobileMenuOpen = useSelector((state: any) => state.appsettings.isMobileMenuOpen)
  const isMobileView = useSelector((state: any) => state.appsettings.isMobileView)
  // const appsettings = useSelector((state) => state.appsettings)

  const [mobileMenuState, setMobileMenuState] = useState(isMobileMenuOpen)

  // const dispatch = useDispatch()

  useEffect(() => {
    applyMobileMenuState()
  }, [isMobileMenuOpen])

  const applyMobileMenuState = () => {
    setMobileMenuState(isMobileMenuOpen)
  }

  useEffect(() => {
    // mobile menu touch slide opener
    const unify = (e: TouchEvent | MouseEvent): any => {
      return (e as TouchEvent).changedTouches ? (e as TouchEvent).changedTouches[0] : e
    }
    document.addEventListener(
      'touchstart',
      (e) => {
        const x = (unify(e) as Touch).clientX
        touchStartPrev = x
        touchStartLocked = x > 70
      },
      { passive: false },
    )
    document.addEventListener(
      'touchmove',
      (e) => {
        const x = (unify(e) as Touch).clientX
        const prev = touchStartPrev
        if (x - prev > 50 && !touchStartLocked) {
          toggleMobileMenu()
          touchStartLocked = true
        }
      },
      { passive: false },
    )
  }, [])

  const toggleMobileMenu = () => {
    setMobileMenuState(!mobileMenuState)
  }

  // const setMobileMenuOpen = (value) => {
  //   dispatch({
  //     type: 'appsettings/CHANGE_SETTING',
  //     payload: {
  //       setting: 'isMobileMenuOpen',
  //       value,
  //       // value: false,
  //     },
  //   })
  // }

  const GetMenu = () => {
    if (isMobileView === true) {
      // menuWidth = 80 + 376;

      // const drawerAttrs = {
      //   closable: false,
      //   open: mobileMenuState,
      //   afterOpenChange: (open) => {
      //     setMobileMenuOpen(open)
      //   },
      //   placement: 'left',
      //   className: styles.mobileMenu,
      //   onClose: () => {
      //     setMobileMenuOpen(false)
      //   },
      //   maskClosable: true,
      //   getContainer: null,
      //   // width: menuWidth
      // }

      // return (
      //   <div>
      //     <div
      //       className={styles.handler}
      //       onClick={toggleMobileMenu}
      //       onFocus={(e) => {
      //         e.preventDefault()
      //       }}
      //       onKeyDown={toggleMobileMenu}
      //       role="button"
      //       tabIndex="0"
      //     >
      //       <div className={styles.handlerIcon} />
      //     </div>
      //     <Drawer {...drawerAttrs}>
      //       <MenuLeft />
      //       <div className={classNames('menuPortal')} id="portalLeftSideMenu" />
      //     </Drawer>
      //   </div>
      // )
      return <MenuLeft location={location} />
    }
    if (menuLayoutType === 'top') {
      return <MenuTop location={location} />
    }
    if (menuLayoutType === 'nomenu') {
      return null
    }
    return <MenuLeft location={location} />
  }

  return GetMenu()
}

export default withRouter(Menu)
